export default [
  {
    path: '/scan',
    name: 'scan',
    meta: { requiresGuest: true },
    component: () => import('@/pages/QrcodeDisplayCertificate.vue')
  },
  {
    path: '/scan-barcode',
    name: 'scan-barcode',
    meta: { requiresGuest: true },
    component: () => import('@/pages/barcdeDisplayCertificate.vue')
  }
]
